import { SET_BUTTONS_ARRAY_POSITION } from './constants'

export function setPosition(moduleName, arrayName, position = 0, maxPosition = 0) {
    return {
        type: SET_BUTTONS_ARRAY_POSITION,
        data: {
            moduleName,
            arrayName,
            position,
            maxPosition,
        },
    }
}
